/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */


const $el   = $(el);
const $form = $el.find('.wrap-login');
const $cpf  = $form.find('[name="cpf"]');
const $btn  = $form.find('[type="submit"]');
const btn   = $btn[0];
const isPt  = document.documentElement.lang == 'pt';

const $requireds = $form.find('[required]');

function countFalseInObject(obj) {
    let count = 0;

    for (const key in obj) {
      if (obj[key] === false) {
        count++;
      }
    }

    return count;
}

function handleValidation() {
    const formInvalidsNumber = countFalseInObject(formValidate.invalid);
    const formRequiredNumber = $requireds.length;

    if(formInvalidsNumber == formRequiredNumber) {
        $btn.removeAttr('disabled');
    } else {
        $btn.attr('disabled', true);
    }
}

const formValidate = $form.validate({
    highlight: function(element, errorClass, validClass) {
        const $elm = $(element).parents('.box-input');

        $elm.addClass(errorClass).removeClass(validClass);

        return false;
    },
    unhighlight: function(element, errorClass, validClass) {
        const $elm = $(element).parents('.box-input');

        $elm.removeClass(errorClass).addClass(validClass);

        return false;
    },
    errorPlacement: function(error, element) {
        return false
    },
    success: function(label) {
        handleValidation();
    },
    rules: {
        cpf: {
            required: true,
            // cpfBR: (isPt) ? true : false
            cpfBR: true
        },
    },
    submitHandler: function(form) {
        // const formData = $(form).serialize();
        // btn.classList.add('sending');
        // btn.disabled = true;

        // $.post(window.location.href, formData, function(response) {
        //     Navigation.helpers.scrollTo(0);

        //     $document.trigger('remoteTrack', [category, action]);
        // }, 'json').fail(function(response) {
        // });
    }
});

$cpf.mask('000.000.000-00', {reverse: true});

$requireds.on("change", function() {
    handleValidation();
});
